/**
 * Feature中介房源展示(Carousel)
 * 
 * @Author: Focci
 * @Date: 2024-10-11 16:39:51
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-11 16:39:51
 */

'use client'

import useFetch from '@hook/useFetch'
// import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import clsx from 'clsx'
import { filter, map } from 'lodash-es'
import { useCallback, useMemo, useState } from 'react'
import { Waypoint } from 'react-waypoint'

export default function FeatureAgentProperties({ house }) {
  const featureAgents = useMemo(() => (
    filter(house.agents, (agent) => agent.membership_level > 1)
  ), [house.agents])
  
  const [enter, setEnter] = useState(false)
  const { Wedget: FeatureAgentPropertiesCard, getWedget, ready } = useLazyComponent()

  const agentIds = map(featureAgents, 'id')
  const { data, isLoading } = useFetch(enter ? 'agents/houses' : null, { limit: 6, agentIds })
  
  const handleEnter = useCallback(() => {
    getWedget(() => import('./FeatureAgentPropertiesCard'))
    setEnter(true)
  }, [getWedget])

  if(featureAgents.length === 0) return null

  return (
    <Waypoint onEnter={handleEnter}>
      <div className={clsx(['mt-6', (!ready || isLoading) && 'h-[22rem] bg-cf8'])}>
        <FeatureAgentPropertiesCard
          office={house?.office}
          agents={featureAgents} 
          data={data?.houses} 
        />
      </div>
    </Waypoint>
  )
}

// FeatureAgentProperties.propTypes = {
//   className: PropTypes.string,
// }
